export default __webpack_public_path__ + "static/media/jquery.fcc48022.svg";